import { AppSourceFallback } from '@/components/shared/app-source/fallback'
import { ViewAppButtonFallback } from '@/components/shared/view-app/fallback'
import { AppDeployDetailsFallback } from '@/routes/app/tabs/deployment/deploy-details/deploy-details-fallback'
import { AppDeployLogsFallback } from '@/routes/app/tabs/deployment/deploy-logs/deploy-logs-fallback'
import * as Styled from '@/routes/app/tabs/deployment/styles'

export const AppDeploymentTabFallback = () => {
  return (
    <Styled.PageGrid>
      <Styled.DeploymentPageHeader>
        <AppSourceFallback hideBranch />
        <ViewAppButtonFallback />
      </Styled.DeploymentPageHeader>
      <AppDeployLogsFallback />
      <AppDeployDetailsFallback />
    </Styled.PageGrid>
  )
}
